// TelcoTrack — polygon investor (stavebník) from metadata / diaryConfig.

function asRecord(value: unknown): Record<string, unknown> | null {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) return null;
  return value as Record<string, unknown>;
}

function asNonEmptyString(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

/** Stavebník / investor from polygon metadata (`diaryConfig.stavebnik`). */
export function readPolygonInvestorFromMetadata(metadata: unknown): string | null {
  if (metadata == null) return null;
  if (typeof metadata === 'string') return asNonEmptyString(metadata);
  const meta = asRecord(metadata);
  if (!meta) return null;
  const direct = asNonEmptyString(meta['stavebnik']);
  if (direct) return direct;
  const diary = asRecord(meta['diaryConfig']);
  const fromDiary = asNonEmptyString(diary?.['stavebnik']);
  if (fromDiary) return fromDiary;
  return null;
}
